module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question"
  }, [(_vm.commonQuestionList && _vm.commonQuestionList.length > 0) ? _c('ul', _vm._l((_vm.commonQuestionList), function(item) {
    return _c('li', {
      key: item._id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'QuestionDetail',
          query: {
            id: item._id,
            type: 'quesion'
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.remark ? '• ' + item.remark : '') + "\n      ")])], 1)
  })) : _vm._e(), (_vm.commonQuestionList && _vm.commonQuestionList.length === 0) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无内容")]) : _vm._e(), (_vm.total > _vm.pageSize) ? _c('el-pagination', {
    staticClass: "page",
    attrs: {
      "background": "",
      "current-page": _vm.pageNum,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "sizes, total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-670d434f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductDocument/components/commonQuestion.vue
// module id = 406
// module chunks = 0